import React, {useState, useEffect, useCallback, useRef} from "react";
import I18n from 'i18n.js.erb'
import {
  parseAmount,
  CURRENCY_EURO, parseBigInteger, pluralize, isPresent, titleize, titleizeAll, isDefined
} from "../../utils/utils";



const SubmissionListPricingSummary = ({
    title,
    pricingType,
    baseServiceAmount,
    itemsCount,
    userCredit,
    discount,
    backofficeDiscount,
    shippingCost,
    insuranceCost,
    homePickUpCost,
    amount,
    extraServiceAmount,
    extraItemsCount
  }) => {

  return <div className="row">
    <div className="col-8">
      <div className="d-block pl-2 pr-2">
        <p className="text-weight-700">
          {(title ? title : I18n.t('js.editSubmissionListPage.submissionSummaryTitle')) + I18n.t('js.editSubmissionListPage.webComponent.draft.vatIncluded')}
        </p>

        <p>
          {parseAmount(baseServiceAmount)}{CURRENCY_EURO}&nbsp;&nbsp;
          <span className="font-style-italic">
          {I18n.t(pricingType === 'revenue' ? 'js.editSubmissionListPage.submissionSummaryRevenue' : 'js.editSubmissionListPage.submissionSummaryServiceAmount')}&nbsp;
            {parseBigInteger(itemsCount)}&nbsp;
            {pluralize(itemsCount, 'editSubmissionListPage.product')}
        </span>
        </p>

        {
          !backofficeDiscount && discount && (discount.amount || discount.percentage) &&
          <p>
            -{isPresent(discount.amount) ? parseAmount(discount.amount) + CURRENCY_EURO : discount.percentage + '%'}&nbsp;&nbsp;
            <span className="font-style-italic">
              {I18n.t('js.editSubmissionListPage.submissionSummaryDiscount')}
            </span>
          </p>
        }

        {
          isPresent(extraItemsCount) && extraItemsCount > 0 &&
          <p>
            +{parseAmount(extraServiceAmount)}{CURRENCY_EURO}&nbsp;&nbsp;
            <span className="font-style-italic">
            {I18n.t(pricingType === 'revenue' ? 'js.editSubmissionListPage.submissionSummaryRevenue' : 'js.editSubmissionListPage.submissionSummaryServiceAmount')}&nbsp;
              {parseBigInteger(extraItemsCount)}&nbsp;
              {pluralize(extraItemsCount, 'editSubmissionListPage.extraProduct')}&nbsp;
              {pluralize(extraItemsCount, 'editSubmissionListPage.addedByGrader')}
            </span>
          </p>
        }

        {
          !discount && backofficeDiscount && (backofficeDiscount.amount || backofficeDiscount.percentage) &&
          <p>
            -{isPresent(backofficeDiscount.amount) ? parseAmount(backofficeDiscount.amount) + CURRENCY_EURO : backofficeDiscount.percentage + '%'}&nbsp;&nbsp;
            <span className="font-style-italic">
              {I18n.t('js.editSubmissionListPage.submissionSummaryDiscount')}
            </span>
          </p>
        }

        {
          isPresent(homePickUpCost) &&
          <p>
            +{parseAmount(homePickUpCost)}{CURRENCY_EURO}&nbsp;&nbsp;
            <span className="font-style-italic">
            {I18n.t('js.editSubmissionListPage.submissionSummaryHomePickUpCost')}
          </span>
          </p>
        }

        {
          isPresent(shippingCost) &&
          <p>
            +{parseAmount(shippingCost)}{CURRENCY_EURO}&nbsp;&nbsp;
            <span className="font-style-italic">
            {I18n.t('js.editSubmissionListPage.submissionSummaryShippingCost')}
          </span>
          </p>
        }

        {
          isPresent(insuranceCost) &&
          <p>
            +{parseAmount(insuranceCost)}{CURRENCY_EURO}&nbsp;&nbsp;
            <span className="font-style-italic">
            {I18n.t('js.editSubmissionListPage.submissionSummaryInsuranceCost')}
          </span>
          </p>
        }

        {
          isDefined(userCredit) &&
          <p>
            -{parseAmount(userCredit, 2) + CURRENCY_EURO}&nbsp;&nbsp;
            <span className="font-style-italic">
              of credit available on the user's wallet
            </span>
          </p>
        }

        <div className="border-top-dark mt-2 text-weight-700">
          <h3>
            <b>{parseAmount(amount)}{CURRENCY_EURO}</b>
          </h3>
        </div>
      </div>
    </div>

    <div className="col-4">
      <div className="d-block pl-2 pr-2">
        <p className="text-weight-700">
          Legend:
        </p>

        <p className="color-green">
          Base {pricingType === 'revenue' ? 'Revenue' : 'Service Amount'}
        </p>

        {
          !backofficeDiscount && discount && (discount.amount || discount.percentage) &&
          <p className="color-aig-blue">
            Discount
          </p>
        }

        {
          isPresent(extraItemsCount) && extraItemsCount > 0 &&
          <p className="color-green">
            Extra {pricingType === 'revenue' ? 'Revenue' : 'Service Amount'}
          </p>
        }

        {
          !discount && backofficeDiscount && (backofficeDiscount.amount || backofficeDiscount.percentage) &&
          <p className="color-aig-blue">
            Backoffice Discount
          </p>
        }

        {
          isPresent(homePickUpCost) &&
            <p className="color-dark-orange">
              Home Pick Up Cost
            </p>
        }

        {
          isPresent(shippingCost) &&
            <p className="color-dark-orange">
              Shipping Cost
            </p>
        }

        {
          isPresent(insuranceCost) &&
          <p className="color-aig-purple">
            Insurance Cost
          </p>
        }

        {
          isDefined(userCredit) &&
          <p className="color-aig-blue">
            User Credit
          </p>
        }

        <div className="border-top-dark pt-5 text-weight-700">
          {['amount', 'customer_amount'].includes(pricingType) ? `Global ${titleizeAll(pricingType)}` : titleizeAll(pricingType)}
        </div>
      </div>
    </div>
  </div>
};

export default SubmissionListPricingSummary;